import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Blog from "../components/Blog";
import Newsletter from "../components/Newsletter";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import NewsletterPopup from "../components/NewsletterPopup";

export default function Home() {
  return (
    <div className="bg-[#f5fbfc] dark:bg-slate-950 transition-colors">
      <Navbar />
      <Hero />
      <About />
      <Projects />
      <Blog />
      <Newsletter />
      <Contact />
      <Footer />
      <NewsletterPopup />
    </div>
  );
}